import { render } from "./DemoOverlayComponent.vue?vue&type=template&id=5ab11aee&scoped=true"
import script from "./DemoOverlayComponent.vue?vue&type=script&lang=ts"
export * from "./DemoOverlayComponent.vue?vue&type=script&lang=ts"

import "./DemoOverlayComponent.vue?vue&type=style&index=0&id=5ab11aee&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5ab11aee"

export default script